var map = {
	"./black/camerafor.png": "EVGL",
	"./blue/camerafor.png": "2XMU",
	"./white/camerafor.png": "pXud"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6Kqg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/camerafor\.png$
// module id = 6Kqg
// module chunks = 24